import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { withBreakpoints } from 'react-breakpoints';
import { isEqual, isFunction, orderBy } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import { convertToDisplayValue } from 'helpers/strings';
import { DESKTOP_LIMIT, MOBILE_LIMIT } from 'constants/charts';
import helpers from 'helpers';

class GroupedBarChartWithCategories extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const {
            keys,
            data,
            partitionBy,
            tooltipFormatter,
            showTopOnly,
            breakpoints,
            currentBreakpoint,
            filterField
        } = this.props;
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;

        const keysFlattened = keys.map(k => k.key);
        let filteredData = orderBy(data, keys, Array(keysFlattened.length)
            .fill('desc'))
            .filter(item => item[filterField]);

        if (showTopOnly) {
            if (breakpoints[currentBreakpoint] >= breakpoints.sm) {
                filteredData = filteredData.slice(0, DESKTOP_LIMIT);
            } else {
                filteredData = filteredData.slice(0, MOBILE_LIMIT);
            }
        }

        const series = [];
        for (const [index, item] of keys.entries()) {
            let key = item;
            let seriesName;

            if (typeof item === 'object') {
                key = item.key;
                seriesName = item.title || convertToDisplayValue(item.key);
            } else {
                seriesName = convertToDisplayValue(key);
            }

            series.push({
                name: seriesName,
                color: orderedColors[index % orderedColors.length],
                data: filteredData.map(r => r[key])
            });
        }

        const options = {
            categories: filteredData.map(d => d[partitionBy])
        };

        const xAxis = helpers.xAxisConfig({
            xAxisLabel: this.props.xAxisLabel,
            options
        });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                borderWidth: 0
            }
        };

        const tooltipOptions = {
            shared: true,
            followPointer: true,
        };

        if (isFunction(tooltipFormatter)) {
            tooltipOptions.formatter = tooltipFormatter;
        }

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'column',
                            backgroundColor: 'rgba(255, 255, 255, 0.0)',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        legend: {
                            padding: 10,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: tooltipOptions,
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(withBreakpoints(GroupedBarChartWithCategories));



// WEBPACK FOOTER //
// ./src/components/molecules/charts/GroupedBarChartWithCategories.js